

import React, { useEffect } from 'react';
import ProBg from "./proBg.jpg"

const Mspipe = () => {
    useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when this page loads
  }, []);
  return (
    <div>
      <section
        className="featured-job-area section-padding30 section-bg2"
        style={{
         backgroundImage: `url(${ProBg})`, backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '400px',  // Adjust the height here
        }}
      >
        <div className="container">
          <div className="row justify-content">
            <div className="col-xl-7 col-lg-9 col-md-10 col-sm-12">
              {/* Section Title */}
              <div className="section-tittle text-left mb-80">
                <h2>Ms Pipe</h2>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            {/* Add content here */}
          </div>
        </div>
      </section>

      <section className="about-low-area section-padding2" style={{ marginTop: '-50px' }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-10">
              <div className="about-caption mb-11">
                <div className="section-tittle mb-11">
                  {/* <span>About Al Hadeed Steel</span> */}
                  {/* <h2>Building the Future with Strength and Durability</h2> */}
                </div>
                <p style={{lineHeight:"2.4"}}>
<h3>Mild Steel</h3>
<p>
Mild steel is the most affordable type of steel and the most commonly used in various applications. It is highly versatile, weldable, and durable, although it tends to rust easily. Comprising a maximum of 0.29% carbon, mild steel can be magnetized and is suitable for projects requiring large amounts of metal. However, its structural strength is insufficient for load-bearing girders and beams.
</p>
<p>
Common applications include the manufacturing of automobile chassis, motorcycle frames, and most cookware. Due to its poor resistance to corrosion, mild steel requires protective measures like painting, sealing, or coating with oil or grease to prevent rust. Unlike high-carbon steel, mild steel is easier to weld as its composition allows electrical currents to pass without altering its structure. While high-carbon steels like stainless steel require specialized welding techniques, mild steel's flexibility and reduced brittleness make it a preferred choice in construction projects.
</p>
<p>
Mild steel is extensively used in pipelines due to its weldability and ability to flex under pressure, reducing the risk of cracking. However, its susceptibility to corrosion necessitates sealing methods like painting or wrapping with corrosion-resistant materials. This steel type is ideal for low-pressure conveyance of air, steam, gas, water, oil, and other fluids, primarily in machinery, buildings, irrigation systems, and sprinkler systems, rather than distribution pipelines.
</p>

<h3>MS Pipe and MS Tube</h3>
<p>
MS Pipe and MS Tube, referring to Mild Steel Pipes and Tubes, are commonly used for structural and load-bearing purposes in the construction industry. These pipes and tubes are also utilized in shipbuilding, trucks, farm equipment, and various industrial and domestic applications.
</p>
<p>
Uses include:
<ul>
  <li><strong>Structural:</strong> Sheds, scaffolding, railings, stairs, tents, doors.</li>
  <li><strong>Industrial:</strong> Tools, trolleys, machinery, supports, barricades, poles.</li>
  <li><strong>Automotive:</strong> Chassis, steering systems, tools, and parts.</li>
  <li><strong>Domestic:</strong> Doors, railings, stairs, decorative elements, tents, fencing.</li>
  <li><strong>Furniture:</strong> Chairs, tables, racks, storage systems.</li>
</ul>
</p>

<h3>What is Pipe Schedule?</h3>
<p>
Pipes are primarily designed to carry fluids under pressure, making their internal diameter (known as the nominal bore or NB) a critical dimension. Wall thickness, which directly impacts a pipe's strength, is specified using "schedules," abbreviated as SCH. For a given pipe size, the thickness associated with each schedule is fixed and defined in the applicable ASME standard. In addition to schedules, pipe thickness may be specified in millimeters or inches, correlating to ASME standards.
</p>

<h3>What Standards Govern Pipe Sizes?</h3>
<p>
The oil and gas industry and related downstream sectors primarily follow these standards:
<ul>
  <li>ASME/ANSI B 36.10 – Welded and Seamless Wrought Steel Pipe</li>
  <li>ASME/ANSI B 36.19 – Stainless Steel Pipe</li>
</ul>
</p>

<h3>Does Pipe Schedule Change with Pipe Size?</h3>
<p>
For all pipe sizes, the outer diameter remains constant. However, variations in schedule (i.e., wall thickness) affect only the inner diameter. As the schedule number increases, the wall thickness increases, reducing the actual bore. 
</p>
<p>
Some common equivalences include:
<ul>
  <li>STD is equivalent to SCH 40 for NPS 1/8 to NPS 10.</li>
  <li>XS is equivalent to SCH 80 for NPS 1/8 to NPS 8.</li>
  <li>XXS walls are thicker than SCH 160 for NPS 1/8″ to NPS 6″ but thinner for NPS 8″ and larger.</li>
</ul>
</p>

<h3>Pipe Schedule Charts</h3>
<p>
The wall thickness for a specific schedule depends on the pipe size, as illustrated in standard charts. Stainless steel pipes are typically available in standard weight sizes (e.g., "NPS SCH 10S") but may also come in other schedules. Common abbreviations include:
<ul>
  <li>NPS – Nominal Pipe Size</li>
  <li>NB – Nominal Bore</li>
  <li>STD – Standard</li>
  <li>XS – Extra Strong</li>
  <li>XXS – Double Extra Strong</li>
</ul>
</p>

 </p>
                
              </div>
            </div>
          </div>
                <div className="container my-4">
            <h2 className="text-center mb-4">Theoretical Weight Table</h2>
            <div className="table-responsive">
                <table className="table table-bordered">
  <thead className="table-dark">
    <tr>
      <th>NPS (inches)</th>
      <th>N.B.</th>
      <th>O.D. (mm)</th>
      <th>10</th>
      <th>20</th>
      <th>30</th>
      <th>STD</th>
      <th>40</th>
      <th>60</th>
      <th>XS</th>
      <th>80</th>
      <th>100</th>
      <th>120</th>
      <th>140</th>
      <th>160</th>
      <th>XXS</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>1/8</td>
      <td>6</td>
      <td>10.3</td>
      <td>1.24</td>
      <td>–</td>
      <td>1.45</td>
      <td>1.73</td>
      <td>1.73</td>
      <td>–</td>
      <td>2.41</td>
      <td>2.41</td>
      <td>–</td>
      <td>–</td>
      <td>–</td>
      <td>–</td>
      <td>–</td>
    </tr>
    <tr>
      <td>1/4</td>
      <td>8</td>
      <td>13.7</td>
      <td>1.65</td>
      <td>–</td>
      <td>1.85</td>
      <td>2.24</td>
      <td>2.24</td>
      <td>–</td>
      <td>3.02</td>
      <td>3.02</td>
      <td>–</td>
      <td>–</td>
      <td>–</td>
      <td>–</td>
      <td>–</td>
    </tr>
    <tr>
      <td>3/8</td>
      <td>10</td>
      <td>17.1</td>
      <td>1.65</td>
      <td>–</td>
      <td>1.85</td>
      <td>2.31</td>
      <td>2.31</td>
      <td>–</td>
      <td>3.2</td>
      <td>3.2</td>
      <td>–</td>
      <td>–</td>
      <td>–</td>
      <td>–</td>
      <td>–</td>
    </tr>
    <tr>
      <td>1/2</td>
      <td>15</td>
      <td>21.34</td>
      <td>2.11</td>
      <td>–</td>
      <td>2.41</td>
      <td>2.77</td>
      <td>2.77</td>
      <td>–</td>
      <td>3.73</td>
      <td>3.73</td>
      <td>–</td>
      <td>–</td>
      <td>–</td>
      <td>4.77</td>
      <td>7.47</td>
    </tr>
    <tr>
      <td>3/4</td>
      <td>20</td>
      <td>26.67</td>
      <td>2.11</td>
      <td>–</td>
      <td>2.41</td>
      <td>2.87</td>
      <td>2.87</td>
      <td>–</td>
      <td>3.91</td>
      <td>3.91</td>
      <td>–</td>
      <td>–</td>
      <td>–</td>
      <td>5.56</td>
      <td>7.82</td>
    </tr>
    <tr>
      <td>1</td>
      <td>25</td>
      <td>33.4</td>
      <td>2.77</td>
      <td>–</td>
      <td>2.90</td>
      <td>3.38</td>
      <td>3.38</td>
      <td>–</td>
      <td>4.55</td>
      <td>4.55</td>
      <td>–</td>
      <td>–</td>
      <td>–</td>
      <td>6.35</td>
      <td>9.09</td>
    </tr>
    <tr>
      <td>1.1/4</td>
      <td>32</td>
      <td>42.16</td>
      <td>2.77</td>
      <td>–</td>
      <td>2.97</td>
      <td>3.56</td>
      <td>3.56</td>
      <td>–</td>
      <td>4.85</td>
      <td>4.85</td>
      <td>–</td>
      <td>–</td>
      <td>–</td>
      <td>6.35</td>
      <td>9.7</td>
    </tr>
    <tr>
      <td>1.1/2</td>
      <td>40</td>
      <td>48.26</td>
      <td>2.77</td>
      <td>–</td>
      <td>3.18</td>
      <td>3.68</td>
      <td>3.68</td>
      <td>–</td>
      <td>5.08</td>
      <td>5.08</td>
      <td>–</td>
      <td>–</td>
      <td>–</td>
      <td>7.14</td>
      <td>10.16</td>
    </tr>
    <tr>
      <td>2</td>
      <td>50</td>
      <td>60.32</td>
      <td>2.77</td>
      <td>–</td>
      <td>3.18</td>
      <td>3.91</td>
      <td>3.91</td>
      <td>–</td>
      <td>5.54</td>
      <td>5.54</td>
      <td>–</td>
      <td>–</td>
      <td>–</td>
      <td>8.74</td>
      <td>11.07</td>
    </tr>
  </tbody>
</table>

            </div>
        </div>
        </div>
      </section>
    </div>
  );
}

export default Mspipe;
